// Finds deals whose closing date was invented by the app rather than entered
// by a person. Pure and Firebase-free so the rule can be tested directly.
//
// Until 2026-08-16 four code paths stamped "today" into a blank closing date
// (see buildTurnInSeed and add-deal). The fingerprint they all left is the
// same: closingdate equals the calendar day the deal was created.
//
// Two clocks were involved — buildTurnInSeed used toISOString (UTC), add-deal
// used moment (local) — so an evening turn-in could carry either day. Both
// count as guesses.
//
// This is a HEURISTIC, not proof: a deal genuinely closing the day it was
// entered looks identical. That's why the audit lists deals for review instead
// of clearing them on sight.

const ISO_DAY = /^\d{4}-\d{2}-\d{2}$/;

function dayKeys(ms) {
  const d = new Date(ms);
  if (Number.isNaN(d.getTime())) return [];
  const utc = d.toISOString().slice(0, 10);
  const local = [
    d.getFullYear(),
    String(d.getMonth() + 1).padStart(2, "0"),
    String(d.getDate()).padStart(2, "0"),
  ].join("-");
  return utc === local ? [utc] : [utc, local];
}

export function looksLikeGuessedClosingDate(deal) {
  const closing = deal?.closingdate;
  if (typeof closing !== "string" || !ISO_DAY.test(closing)) return false;

  const created = Number(deal?.createdat);
  if (!created) return false;

  return dayKeys(created).includes(closing);
}

export function auditDealsForGuessedClosingDates(deals) {
  return (Array.isArray(deals) ? deals : [])
    .filter(looksLikeGuessedClosingDate)
    .map((d) => ({
      id: d.id,
      closingdate: d.closingdate,
      propertyaddress: d.propertyaddress || "(no address)",
      dealStage: d.dealStage || "",
      agentName: d.agentName || "",
      createdOn: new Date(Number(d.createdat)).toISOString().slice(0, 10),
      createdat: Number(d.createdat),
    }))
    .sort((a, b) => b.createdat - a.createdat);
}
